import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { MenuComponent } from 'src/app/layout/components/menu/menu.component';

@Injectable({
  providedIn: 'root'
})
export class DatosCompartidosService {

  private tokenNumber = new BehaviorSubject<number>(0);
  tokenNumber$ = this.tokenNumber.asObservable();

  private closeUserSession = new BehaviorSubject<any>(0);
  closeUserSession$ = this.closeUserSession.asObservable();

  private IDUsrKeycloak = new BehaviorSubject<any>(null);
  IDUsrKeycloak$ = this.IDUsrKeycloak.asObservable();

  private dataUser = new BehaviorSubject<any>(null);
  user$ = this.dataUser.asObservable();

  private dataToken = new BehaviorSubject<any>(null);
  token$ = this.dataToken.asObservable();

  private dataUserInfo = new BehaviorSubject<any>(null);
  userInfo$ = this.dataUserInfo.asObservable();

  private datalogoutURL = new BehaviorSubject<any>(null);
  logoutURL$ = this.datalogoutURL.asObservable();

  private cerrarSesion: boolean;

  private registradoEnVital = new BehaviorSubject<any>(null);
  registradoEnVital$ = this.registradoEnVital.asObservable();

  constructor() {}

  setCerrarSesion(value: boolean) {
    this.cerrarSesion = value;
  }

  setIDUsrKeycloak(dataIdUsr: any) {
    this.IDUsrKeycloak.next(dataIdUsr);
  }

  setUser(user: any) {
    this.dataUser.next(user);
  }
  
  setUserInfo(userInfo:any){
    this.dataUserInfo.next(userInfo);
  }

  getUserInfo():any{
    return this.dataUserInfo.value; 
  }
  setToken(token:string){
    this.dataToken.next(token)
  }

  getToken():string{
    return this.dataToken.value; 
  }

  setLogoutUrl(url: string) {
    this.datalogoutURL.next(url);
  }

  setCloseUserSession(value: number) {
    this.closeUserSession.next(value);
  }

  increaseTokenNumber(): void {
    this.tokenNumber.next(this.tokenNumber.value + 1);
  }

  getTokenNumber(): number {
      return this.tokenNumber.value;
  }

  getLogoutUrl(): string {
    return this.datalogoutURL.value;
  }

  public getUser(): any {
    return this.dataUser.value;
  }

  getCerrarSesion(): boolean {
    return this.cerrarSesion;
  }

  setRegistradoEnVital(regisVitalString: string) {
    this.registradoEnVital.next(regisVitalString == "true");
  }

  getRegistradoEnVital(): boolean {
    return this.registradoEnVital.value;
  }

}